import { Link } from 'gatsby'
import React from 'react'

export default function MyLink({ to, target, children, ...rest }) {
    return (
        <>
            {target !== "_blank" && (to?.startsWith("/") || to?.startsWith("#")) ?
                <Link to={to}  {...rest}>
                    {children}
                </Link>
                :
                <a href={to} target={"_blank"} rel={`noreferrer`} {...rest}>
                    {children}
                </a>}
        </>
    )
}
